<div  id="SubscribeBoxModal" class="modal fade" tabindex="-1" role="dialog"
  [config]="{ show: true, backdrop: 'static' }" (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
  <div class="container" *ngIf="storyTutorialStep === 0">
    <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12 px-0">
      <div  class="row margin-top-22px">
          <div class="col-lg-8 pr-md-0 mx-0">
            <div class="row">
              <div class="col-lg-4 pr-md-0 d-none d-lg-block">
              </div>
              <div class="col-lg-8 px-0  mobile-view background-effect mx-0">
                <div class="bg-white mb-3 px-3 pt-3 pb-2 custom-owl-carousel">
                  <owl-carousel-o [options]="customOptionsForStoriesList" *ngIf="userStoryList?.length > 0" #owlCarousel>
                    <ng-template *ngFor="let story of userStoryList;trackBy:trackByFn; let i = index"  carouselSlide [width]="132" >
                      <div class="overflow-hidden border-radius-8">
                        <app-thumbnail-views [youText]="youText" [isCreationMode]="false" [isMe]="story.type === 'ME' ? true : false " [listing]="true" class="story-thumbnail cursor-pointer"[backGroundImage]="story.carouselCode !='' ? story.carouselCode : 'assets/images/grandround/image_placeholder.svg'"[thumbnailInfo]="story" [activeStatus]="1" noInfoSrc = 'assets/images/no-story.svg'></app-thumbnail-views>
                      </div>
                    </ng-template>
                  </owl-carousel-o>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 d-none d-lg-block"></div>
      </div>
  </div>
  </div>
  <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered tutorial-model" [ngClass]="{'first-step': storyTutorialStep === 0}">
    <div class="modal-content p-3">
      <div class="modal-header d-flex p-0 border-0 ml-2 mr-3 mt-3" [ngClass]="{'justify-content-end': storyTutorialStep > 0}">
        <button class="new-icon p-2" *ngIf="storyTutorialStep === 0">{{newText}}</button>
        <img class="cursor-pointer" src="assets/images/cross.svg" alt="cross" width="24" height="24"
          (click)="onHidden()" style="width: 24px;">
      </div>
      <div class="mt-3" [ngClass]="{'text-center': storyTutorialStep > 0}">
        <h3 class="heading-3">
          {{introducingText}}
          <span class="stories">{{storiesText}}</span>
        </h3>
        <div class="my-3" *ngIf="centerImage">
            <img *ngIf = "storyTutorialStep === 1" src="assets/images/story-tutorial-1.svg">
            <img *ngIf = "storyTutorialStep === 2" src="assets/images/story-tutorial-2.svg">
            <img *ngIf = "storyTutorialStep === 3" src="assets/images/story-tutorial-3.svg">
        </div>
        <div *ngIf="storyTutorialStep > 0">
          <span class="d-inline-flex dotCreation mr-2" [ngClass]="{'bg-black': storyTutorialStep === 1}"></span>
          <span class="d-inline-flex dotCreation mr-2" [ngClass]="{'bg-black': storyTutorialStep === 2}"></span>
          <span class="d-inline-flex dotCreation" [ngClass]="{'bg-black': storyTutorialStep === 3}"></span>
        </div>
        <p class="paragraph mt-2">
          {{paragraphText}}
        </p>
        <div class="mt-3">
          <button type="button" *ngIf="storyTutorialStep > 0" class="btn-design medium outline" (click)="previousStep()">
            {{primaryButtonText}}
          </button>
          <button type="button" (click)="nextStep()" [ngClass]="{'w-100 ml-0': storyTutorialStep === 0, 'ml-3': storyTutorialStep > 0}" class="btn-design medium filled">
            {{secondaryButtonText}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
